import Workspace from "./workspace";
import useWorkspaceMembership from "../workspace-membership/use-workspace-membership";
import api from "../../system/api";

export async function requestWorkspaceArchive(documentId, client = api) {
  if (!documentId) return null;
  return client.post(`/workspaces/${documentId}/archive`, {}, {
    headers: {workspace: documentId},
    suppressGlobalErrorHandler: true,
  });
}

export async function requestWorkspaceExport(documentId, client = api) {
  if (!documentId) return null;
  return client.get(`/workspaces/${documentId}/export`, {
    headers: {workspace: documentId},
    responseType: "blob",
    suppressGlobalErrorHandler: true,
  });
}

export async function requestWorkspaceImport(documentId, file, client = api) {
  if (!documentId || !file) return null;
  const formData = new FormData();
  formData.append("file", file);
  return client.post(`/workspaces/${documentId}/import`, formData, {
    headers: {workspace: documentId},
    suppressGlobalErrorHandler: true,
  });
}

export function useWorkspace() {
  const workspaceMembership = useWorkspaceMembership();

  const updateWorkspace = async (_documentId, _workspaceData)=>{
    const workspace = new Workspace();
    try {
      const updated = await workspace.updateItem(_documentId, _workspaceData);
      await workspaceMembership.getWorkspaceMemberships();
      return updated?.data || updated || null;
    }catch (e) {
      return null;
    }
  }

  const getOnboardingEligibility = async () => {
    const response = await api.get("/workspace-onboarding/eligibility");
    return response?.data?.data || null;
  };

  const createWorkspace = async (data, {refreshMemberships = true} = {}) => {
    const response = await api.post("/create-workspace", {data});
    if (refreshMemberships) await workspaceMembership.getWorkspaceMemberships();
    return response?.data?.data || null;
  };

  const archiveWorkspace = async (documentId) => {
    if (!documentId) return null;
    const response = await requestWorkspaceArchive(documentId);
    await workspaceMembership.getWorkspaceMemberships();
    return response?.data?.data || null;
  };

  const exportWorkspace = async (documentId) => requestWorkspaceExport(documentId);

  const importWorkspace = async (documentId, file) => {
    const response = await requestWorkspaceImport(documentId, file);
    await workspaceMembership.getWorkspaceMemberships();
    return response?.data?.data || null;
  };

  return {updateWorkspace, createWorkspace, getOnboardingEligibility, archiveWorkspace, exportWorkspace, importWorkspace};
}
